<template>
<section id="osrHfImpactSection" class="section pretty-top-grey" v-if="false">
  <div class="container">
    <h2 class="has-text-centered">{{ $t("profile.OSRBirdStatus.osrHfImpactSection.title") }}</h2>
    <div class="columns is-multiline is-centered">
      <div class="column is-12-tablet is-4-desktop">
        <div class="bold1" v-html="$t('profile.OSRBirdStatus.osrHfImpactSection.description',
        {
          sppName: state.sppName,
          mapYear: state.sppGroup?.hfMapYear,
          energyHF: osrAreaSummary?.energyHF,
          totalHF: osrAreaSummary?.totalHF,
          seismic: osrAreaSummary?.seismic,
          mine: osrAreaSummary?.mine,
          well: osrAreaSummary?.well,
          pipelines: osrAreaSummary?.pipelines,
          industrial: osrAreaSummary?.industrial
        })"></div>
      </div>
      <div class="column is-12-tablet is-8-desktop">
        <simple-map :widthPct="70" :isOSR="true" :hfYear="state.sppGroup?.hfMapYear"/>
        <figure class="" v-html="$t('profile.OSRBirdStatus.osrHfImpactSection.figure', {sppName: state.sppName, startYear: state.sppGroup?.occurrenceMapStartYear, endYear: state.sppGroup?.occurrenceMapEndYear})"/>
      </div>
    </div>
  </div>
</section>

</template>

<script>
import { useApp } from '@/composables/state/profileState';
import HFMap from './HFMap.vue'

export default {
  name: 'osr-hf-map-subsection',
  components: {
    'simple-map': HFMap
  },
  setup () {
    const { state, osrAreaSummary } = useApp();
    return {
      state,
      osrAreaSummary
    }
  }
}
</script>
